import React, { useMemo } from 'react';
import { translate } from '../../../services/translate';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { DebuggerTag, tags } from './Debugger';

interface Props {
    value: DebuggerTag[];
    setValue: React.Dispatch<React.SetStateAction<DebuggerTag[]>>;
    zIndex: number;
    single?: boolean;
}

function DebuggerTagsDropdown({ value, setValue, zIndex }: Props) {
    const items = useMemo(() => Object.keys(tags).map(triggerType => {
        return { label: translate(triggerType), value: triggerType };
    }), []);

    return (
        <FilterDropdown
            label={translate('type')}
            items={items}
            multiple={true}
            mode='BADGE'
            setValue={setValue}
            onChangeValue={(values) => {
                if (values && values.length > 1) {
                    setValue(values as DebuggerTag[]);
                }
            }}
            value={value}
            zIndex={zIndex}
        />
    );
}

export default DebuggerTagsDropdown;
